import React, {useEffect, useState} from 'react';
import List from '@mui/material/List';
import routesConfig from '../../../../../pages/routesConfig';
import NavVerticalGroup from './VerticalNavGroup';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import {useAuthUser} from '@crema/utility/AuthHooks';
import {useSelector} from 'react-redux';

const VerticalNav = () => {
  const {user} = useAuthUser();
  const clickedSOS = useSelector(({settings}) => settings.clickedSOS);
  const permissionCheck = useSelector(({settings}) => settings.permissions);
  const generalSettings = useSelector(({settings}) => settings.generalSettings);
  const [moduleArr, setModuleArr] = useState([]);
  const [subModuleArr, setSubModuleArr] = useState([]);
  useEffect(() => {
    let arr = [];
    let subarr = [];
    permissionCheck?.map((el) => {
      if (!arr.includes(el.moduleName)) arr.push(el.moduleName);
      if (!subarr.includes(el.subModuleName)) subarr.push(el.subModuleName);
    });
    setModuleArr([...arr]);
    setSubModuleArr([...subarr]);
  }, [permissionCheck]);

  const isRateCardItemAllowed = (item) => {
    if (item?.id === 'zoneMaster')
      return generalSettings?.enableZoneBasedRateCard === 'YES';
    if (item?.id === 'garageMaster')
      return generalSettings?.enableGarageBasedRateCard === 'YES';
    return true;
  };

  // Vendor login gets read-only billing access: within the Billing Module,
  // only Billing Reports is visible (Incomplete Trips, Manage Duties and
  // Issues are hidden).
  const isVendor =
    (user?.role || user?.userList?.userRole) === 'VENDOR';
  const isVendorItemAllowed = (item) => {
    if (!isVendor) return true;
    if (
      item?.module === 'Billing' &&
      item?.type === 'item' &&
      item?.url !== '/billing-reports'
    )
      return false;
    return true;
  };

  // The Billing Module parent is shown only when billing is enabled for the
  // corporate (general setting `isBillingEnabled === 'YES'`).
  const isBillingModuleAllowed = (item) => {
    if (item?.id === 'Billing Module')
      return generalSettings?.isBillingEnabled === 'YES';
    return true;
  };

  // The Shuttle Masters item (under Routes) is shown only when the shuttle feature
  // is enabled for the corporate (general setting `isShuttleEnabled === 'YES'`).
  const isShuttleItemAllowed = (item) => {
    if (item?.id === 'shuttleMasters')
      return generalSettings?.isShuttleEnabled === 'YES';
    return true;
  };

  // In staging and production, hide the Billing and Custom Report items under
  // Billing Module.
  const isRestrictedEnv = ['staging', 'production'].includes(
    process.env.REACT_APP_MODE,
  );
  const RESTRICTED_ITEM_IDS = ['Billing', 'Custom Report'];
  const isRestrictedItemAllowed = (item) =>
    !(isRestrictedEnv && RESTRICTED_ITEM_IDS.includes(item?.id));

  const isItemAllowed = (item) =>
    isRateCardItemAllowed(item) &&
    isVendorItemAllowed(item) &&
    isBillingModuleAllowed(item) &&
    isShuttleItemAllowed(item) &&
    isRestrictedItemAllowed(item);

  const filterChildren = (item) => {
    if (!item?.children) return item;
    return {
      ...item,
      children: item.children
        .filter(isItemAllowed)
        .map(filterChildren),
    };
  };

  const filteredRoutesConfig = routesConfig
    .filter(isItemAllowed)
    .map(filterChildren);
  return (
    <List
      sx={{
        position: 'relative',
        padding: 0,
      }}
      component='div'
    >
      {user?.userList?.userStatus != 'DEFAULT' &&
        filteredRoutesConfig.map((item) => (
          <React.Fragment key={item.id}>
            {item.type === 'group' && (
              <NavVerticalGroup item={item} level={0} />
            )}
            {item.type === 'collapse' &&
              (item.permittedRole != 'ALL' ||
                (moduleArr.includes(item.module) &&
                  (user?.userList?.isImpersonate !== 'NO' ||
                    (user?.userList?.userRole != 'SUPERADMIN' &&
                      user?.userList?.userRole != 'TANENTADMIN')))) && (
                <VerticalCollapse
                  item={item}
                  level={0}
                  subModuleArr={subModuleArr}
                />
              )}
            {item.type === 'item' &&
              (item.messageId == 'Home' ||
                item.permittedRole != 'ALL' ||
                (moduleArr.includes(item.module) &&
                  user?.userList?.isImpersonate !== 'NO')) && (
                <>
                  {((user?.userList?.isImpersonate == 'TANENT' &&
                    item.id == 'onboardCorporates') ||
                    item.id != 'onboardCorporates' ||
                    user?.userList?.userRole == 'TANENTADMIN') && (
                    <VerticalItem item={item} level={0} />
                  )}
                </>
              )}
          </React.Fragment>
        ))}
    </List>
  );
};

export default VerticalNav;
